/**
 * English - Date/Time translations
 */
export const dateTime = {
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  daysAgo: '{count} days ago',
  hoursAgo: '{count} hours ago',
  minutesAgo: '{count} minutes ago',
  justNow: 'Just now',
  dateFormat: 'MMM D, YYYY',
  timeFormat: 'h:mm A',
  dateTimeFormat: 'MMM D, YYYY h:mm A',
} as const;